import { useState }  from "react";
import { useDispatch, useSelector } from "react-redux";
import { regions as actionsRegions, log as actionsLog  } from "../../store/actions";
import ApiRegions from '../../api/regions';
import ListWithControls from "../general/ListWithControls";

const { getRegions } = actionsRegions;
const { addToLog } = actionsLog;

const RegionsAll = ({ selectedRegion, fxOnRegionSelect = () => {} }) => {

    let dispatch = useDispatch();

    let items = useSelector(store => store.regions.items);

    const [ regionToRename, setRegionToRename ] = useState(null);

    const selectRegion = region => {
        setTimeout(() => {
            fxOnRegionSelect(region);   
        }, 0);
    };

    const deleteRegion = r => {
        let proceed = window.confirm(`Delete region: ${r.name} [${r.id}]?`);
        if (proceed) {
            ApiRegions.delete(r.id).then(resp => {
                dispatch(addToLog(resp));
                dispatch(getRegions());
                if (selectedRegion.id == r.id) {
                    fxOnRegionSelect(items[0]);
                }
            });
        }
    }

    const renameRegion = (e, r) => {
        e.stopPropagation();
        let proceed = window.confirm(`Rename region: ${r.name} [${r.id}] to ${regionToRename.name}?`);
        if (proceed) {
            ApiRegions.update({ id: r.id, oldName: r.name, newName: regionToRename.name }).then(resp => {
                dispatch(addToLog(resp));
                dispatch(getRegions());
                setRegionToRename(null);
            });
        }
    }

    return (
        <div className="border border-gray-700">
            <div className="text-lg p-2 bg-gray-900">
                All Regions
            </div>
            <ListWithControls 
                items={items} 
                selected={selectedRegion} 
                fxSelectItem={selectRegion} 
                fxRenameItem={renameRegion} 
                fxDeleteItem={deleteRegion}
                itemToRename={regionToRename}
                fxSetItemToRename={setRegionToRename} />
        </div>
    );
}

export default RegionsAll;